export const SITE_TYPE = "SIXSHOP_PRO";

export const SIXSHOP_PRO_PAGE = {
  LOGIN: { target: `${SITE_TYPE}:LOGIN`, url: "/auth/login" },
  SIGNUP: { target: `${SITE_TYPE}:SIGNUP`, url: "/auth/signup" },
  FIND_PASSWORD: {
    target: `${SITE_TYPE}:FIND_PASSWORD`,
    url: "/auth/password/inquiry",
  },
  MY_PAGE: { target: `${SITE_TYPE}:MY_PAGE`, url: "/myPage" },
  CHECK_GUEST_ORDER: {
    target: `${SITE_TYPE}:CHECK_GUEST_ORDER`,
    url: "/auth/guest",
  },
  PRODUCT_CATEGORY: {
    target: `${SITE_TYPE}:PRODUCT_CATEGORY`,
    url: "/categories",
    param: "productListFilter",
  },
  PRODUCT_DETAIL: { target: `${SITE_TYPE}:PRODUCT_DETAIL`, url: "/products" },
  CART: { target: `${SITE_TYPE}:CART`, url: "/cart" },
  ORDER: { target: `${SITE_TYPE}:ORDER`, url: "/orders" },
  POLICY: { target: `${SITE_TYPE}:POLICY`, url: "/terms/policy" },
  PRIVACY: { target: `${SITE_TYPE}:PRIVACY`, url: "/terms/privacy" },
  SIGNUP_PRIVACY: {
    target: `${SITE_TYPE}:SIGNUP_PRIVACY`,
    url: "/terms/agreement/member-privacy",
  },
} as const;
